const actions = {
  set: 'SET::REPORT_ROW',
  get: 'GET::REPORT_ROW'
}

export const setReportRowSelected = state => ({ type: actions.set, reportRow: state })
export const getReportRowSelected = state => state.reportRow

export default actions



// WEBPACK FOOTER //
// ./src/store/report-row/actions.js